<template>
  <GmbSection
      v-if="organizations"
      :childCheckboxActivatedValues="activatedOrganizationSlugs"
      :childCheckboxAllValues="organizationSlugs"
      :childControlGroupId="controlGroupId"
      :childControlKeywordObjs="organizationKeywordObjs"
      :displayLevel="1"
      isCollapsible
      maxHeight="500px"
      title="Sites"
      @child-checkbox-activated-values-changed="
      (newActivatedOrganizationSlugs) =>
        $emit(
          'organization-data-sources-activated-organizations-changed',
          newActivatedOrganizationSlugs
        )
    "
  >
    <template #picto>
      <FdText colorTheme4 fa>
        <i class="far fa-building"/>
      </FdText>
    </template>

    <template #infoSticker>
      <GmbSticker
          :text="activatedOrganizationCount + '/' + organizationCount"
          :isAlert="activatedOrganizationCount !== organizationCount"
      />
    </template>

    <GmbSection
        v-for="(organization, i) in organizations"
        :childRadioButtonActivatedValue="
        organization.selectedAddressIndex != undefined ? organization.addressList[organization.selectedAddressIndex].slug : null
      "
        :class="{ 'mt-2': i != 0 }"
        isCheckbox
        :isCollapsible="hasSeveralAddresses(organization.addressList)"
        :key="i"
        :selfControlGroupId="controlGroupId"
        :selfControlValue="organization.slug"
        :subtitle="
        organization.selectedAddressIndex != undefined ? organization.addressList[organization.selectedAddressIndex].label : null
      "
        :title="organization.label"
        @child-radio-button-value-changed="
        (newActivatedAddressSlug) =>
          $emit(
            'organization-data-sources-activated-address-changed',
            organization.slug,
            newActivatedAddressSlug
          )
      "
    >
      <template #infoSticker>
        <GmbIndividualSticker
            :individual-count="
            organization.baseIndividualCount != undefined
              ? organization.baseIndividualCount
              : '?'
          "
        />
      </template>

      <template v-if="hasSeveralAddresses(organization.addressList)">
        <GmbRow
            v-for="(address, j) in organization.addressList"
            :controlValue="address.slug"
            isRadioButton
            isSelectableTextStyle
            :key="j"
        >
          <FdText tag="span">{{ address.label }}</FdText>
        </GmbRow>
      </template>
    </GmbSection>
  </GmbSection>
</template>

<script>
import {convertAsKeywords, getUniqueId} from "@/helpers";

import FdText from "@/flexdesign/Text";

import GmbIndividualSticker from "@/widgets/IndividualSticker";
import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";

export default {
  name: "GmbSidePanelSourcedOrganizations",

  components: {
    FdText,
    GmbIndividualSticker,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  props: {
    organizations: Array,
  },

  data() {
    return {};
  },

  computed: {
    activatedOrganizationCount() {
      return this.activatedOrganizations != undefined
          ? this.activatedOrganizations.length
          : 0;
    },

    activatedOrganizations() {
      if (this.organizations == undefined) return undefined;

      return this.organizations.filter(
          (organization) => organization.isActivated
      );
    },

    activatedOrganizationSlugs() {
      let slugs = [];
      this.activatedOrganizations.forEach((organization) => {
        slugs.push(organization.slug);
      });
      return slugs;
    },

    controlGroupId() {
      return getUniqueId();
    },

    organizationCount() {
      return this.organizations.length;
    },

    organizationKeywordObjs() {
      let keywordObjs = [];

      this.organizations.forEach((organization) => {
        keywordObjs.push({
          value: organization.slug,
          keywords: convertAsKeywords(organization.label),
        });
      });

      return keywordObjs;
    },

    organizationSlugs() {
      let slugs = [];
      this.organizations.forEach((organization) => {
        slugs.push(organization.slug);
      });
      return slugs;
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    hasSeveralAddresses(addressList) {
      return addressList.length > 1;
    },
  },
};
</script>

<style lang="scss"></style>
